import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';

import { initialState } from './calendar.settings';

const calendarSlice = createSlice({
  initialState,
  name: 'calendar',
  reducers: {
    resetCalendarState: () => initialState,
    setCalendarTimezone: (state, action) => {
      state.selectedTimezone = action.payload;
    },
    setEventId: (state, action) => {
      state.eventId = action.payload;
    },
    setEventInstanceId: (state, action) => {
      state.eventInstanceId = action.payload;
    },
    setProviderTimezone: (state, action) => {
      state.providerTimezone = action.payload;
    }
  }
});

export const {
  resetCalendarState,
  setCalendarTimezone,
  setEventId,
  setEventInstanceId,
  setProviderTimezone
} = calendarSlice.actions;

export const selectEventId = (state: RootState) => state.calendar.eventId;

export const selectEventInstanceId = (state: RootState) => state.calendar.eventInstanceId;

export const selectCalendarTimezone = (state: RootState) => state.calendar.selectedTimezone;

export const selectProviderTimezone = (state: RootState) => state.calendar.providerTimezone;

export default calendarSlice.reducer;
